import { render, staticRenderFns } from "./EditIndividualModal.vue?vue&type=template&id=98e8f120"
import script from "./EditIndividualModal.vue?vue&type=script&lang=ts"
export * from "./EditIndividualModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports